import { createContext } from 'react';
import type { AuthStrategyState } from './auth-strategies/index.js';

export type AuthState = Pick<
  AuthStrategyState,
  'getAccessToken' | 'getRequestHeaders' | 'userInfo'
>;

export const AuthContext = createContext<AuthState | null>(null);
